//#region Imports

import { Component, Injector, ViewEncapsulation, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { throwError } from 'rxjs';
import _ from 'lodash-es';

import { AppConsts } from '@shared/AppConsts';

import {
    BasketArticleDto
} from '@shared/service-proxies/service-proxies';

import { appModuleAnimation } from '@axilla/axilla-shared';

import { AppComponentBase } from '@shared/common/app-component-base';
import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';
//#endregion Imports

@Component({
    selector: 'app-additional-article-selector',
    templateUrl: './additional-article-selector.component.html',
    styleUrls: ['../../../dashboard/dashboard.component.less', './additional-article-selector.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class AdditionalArticleSelectorComponent extends AppComponentBase implements OnInit, OnDestroy {

    @Input() items: any[];

    @Input() multiple?: boolean| null = false ;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    @Output() selectArticle: EventEmitter<any> = new EventEmitter();

    isLoadingArticles: boolean;

    constructor(
        injector: Injector,
        private _webshopService: WebshopService
    ) {
        super(injector);
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {

    }


    resetQuantity(article: BasketArticleDto) {
        article.quantity = 0;
    }

    private _addAdditionalArticle(article: any) {
        if (+article.quantity <= 0 || article.quantity === undefined) {
            return throwError('Item quantity = 0, change ');
        }

        const item = _.cloneDeep(article);
        this._webshopService.addAdditionalArticle(item);
        this.resetQuantity(article);
    }

    addAdditionalArticle($event: Event, article: any) {
        this.preventClick($event);

        article.quantity = 1;
        this._addAdditionalArticle(article);

    }

    preventClick($event: Event) {
        $event.stopPropagation();
    }

}

